import OutsideClickHandler from "react-outside-click-handler";
import { isMobile } from "react-device-detect";

const ConditionalOutsideClick = ({ children, onOutsideClick }) => {
  if (isMobile) return <>{children}</>;
  return (
    <OutsideClickHandler onOutsideClick={onOutsideClick}>
      {children}
    </OutsideClickHandler>
  );
};

export default ConditionalOutsideClick;
